
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punestationtomumbaicabs() {



    const cardData =
    {
        keyword: 'Pune Station to Mumbai Cabs Service',
        heading: 'Skyline Cabs: Pune Station to Mumbai Cabs Service',
        headingDescription: 'Skyline Cabs offers prompt and dependable Pune Station to Mumbai Cabs Service for a seamless travel experience. Whether you are arriving by train and heading to Mumbai for business, leisure, or an airport transfer, we ensure a smooth and comfortable ride. Our fleet of clean, well-maintained vehicles and courteous drivers guarantee timely pickups and safe travel. Book your Pune Station to Mumbai cab with Skyline Cabs today and enjoy hassle-free, affordable transportation.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Pune Station to Dadar Taxi Fare",
      "description": "Skyline Cabs offers affordable and reliable taxi services from Pune Station to Dadar. With options like Innova, Ertiga, and Sedan, we ensure a comfortable and timely journey."
    },
    {
      "name": "Pune Station to Mumbai Airport Taxi",
      "description": "Skyline Cabs provides prompt and professional taxi services from Pune Station to Mumbai Airport. We offer vehicles like Innova, Ertiga, and Sedan to ensure a smooth and timely airport transfer."
    },
    {
      "name": "Pune Station to Mumbai One Way Cab",
      "description": "For a one-way journey from Pune Station to Mumbai, Skyline Cabs offers reliable and cost-effective taxi services. Our fleet includes Innova, Ertiga, and Sedan for a comfortable and smooth ride."
    },
    {
      "name": "Pune Station to Mumbai Airport Innova Crysta",
      "description": "Skyline Cabs provides premium Innova Crysta cabs for your journey from Pune Station to Mumbai Airport. Enjoy a spacious, comfortable, and luxurious ride with professional drivers."
    },
    {
      "name": "Pune Station to Mumbai Ertiga Cab",
      "description": "Travel comfortably with Skyline Cabs from Pune Station to Mumbai Airport in an Ertiga. Ideal for families and small groups, the Ertiga offers ample space for your luggage and passengers."
    },
    {
      "name": "Shivaji Nagar to Mumbai Cab Fare",
      "description": "Skyline Cabs offers affordable and reliable taxi services from Shivaji Nagar to Mumbai. Whether you need a one-way or round-trip ride, we provide vehicles like Innova, Ertiga, and Sedan for your comfort."
    },
    {
      "name": "Pune Station to Borivali Taxi",
      "description": "Skyline Cabs offers reliable and affordable taxi services from Pune Station to Borivali. We provide a variety of vehicles, including Innova, Ertiga, and Sedan, ensuring a comfortable and timely ride."
    },
    {
      "name": "Pune Station to Navi Mumbai Cab Fare",
      "description": "Skyline Cabs provides convenient and affordable taxi services from Pune Station to Navi Mumbai. Our fleet includes vehicles like Innova, Ertiga, and Sedan to ensure a smooth and safe journey."
    },
    {
      "name": "Pune Station to Mumbai Airport Cab Fare",
      "description": "Skyline Cabs offers transparent and affordable taxi services from Pune Station to Mumbai Airport. With options like Innova, Ertiga, and Sedan, we ensure a comfortable and on-time airport transfer."
    },
    {
      "name": "Pune Station to Mumbai Sedan Taxi Fare",
      "description": "Skyline Cabs offers affordable sedan taxi services from Pune Station to Mumbai. Choose from a variety of sedan options like Swift Dzire and Etios for a comfortable and budget-friendly ride."
    },
    {
      "name": "Ertiga on Rent in Pune Station",
      "description": "Skyline Cabs offers Ertiga rentals at Pune Station. Ideal for families or small groups, the Ertiga provides a spacious and comfortable ride for trips to Mumbai, the airport, or other destinations."
    },
    {
      "name": "Innova, Ertiga, Xylo, Tavera Car on Rent Pune Station",
      "description": "Skyline Cabs offers a wide range of vehicles on rent at Pune Station, including Innova, Ertiga, Xylo, and Tavera. These cars are perfect for group travel, family trips, or long-distance journeys."
    },
    {
      "name": "Pune Station to Mumbai Airport Cab",
      "description": "Skyline Cabs provides reliable and comfortable taxi services from Pune Station to Mumbai Airport. Whether you need a one-way or round-trip ride, our fleet ensures a smooth journey."
    },
    {
      "name": "Pune Station to Mumbai Airport Innova",
      "description": "For a premium and comfortable ride from Pune Station to Mumbai Airport, book an Innova with Skyline Cabs. Our well-maintained vehicles and professional drivers ensure a safe and timely journey."
    },
    {
      "name": "Pune to Mumbai Skyline Cabs",
      "description": "Skyline Cabs offers seamless and reliable taxi services between Pune and Mumbai. Whether you’re heading to the airport, for a business trip, or a personal visit, we ensure a comfortable and timely ride."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs offers reliable and professional taxi services within Pune. Whether you're traveling locally or need a ride to Mumbai, our fleet of vehicles ensures comfort and punctuality."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers convenient and affordable taxi services from Pune to Mumbai Airport. Choose from a variety of vehicles like Innova and Ertiga for a comfortable and timely journey."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs provides reliable and efficient taxi services for your journey from Pune to Mumbai. We offer well-maintained vehicles like Innova, Ertiga, and Sedan for a safe and comfortable trip."
    },
    {
      "name": "Pune Station Cab",
      "description": "Skyline Cabs offers efficient and professional cab services at Pune Station. Whether you need a ride to Mumbai or another destination, we provide a variety of vehicles for your comfort."
    },
    {
      "name": "Pune Station Cab Contact Number",
      "description": "Contact Skyline Cabs at [Phone Number] for reliable taxi services at Pune Station. Our friendly and professional staff is available to assist with your booking and travel needs."
    },
    {
      "name": "Full Day Taxi in Pune",
      "description": "Skyline Cabs offers full-day taxi services in Pune. Whether you need a vehicle for business, leisure, or sightseeing, our fleet of cars ensures a comfortable and reliable ride throughout the day."
    }
  ],
  "tableData": [
    ["Pune Station to Dadar Taxi Fare", "Pune Station to Mumbai Airport Taxi"],
    ["Pune Station to Mumbai One Way Cab", "Pune Station to Mumbai Airport Innova Crysta"],
    ["Pune Station to Mumbai Ertiga Cab", "Shivaji Nagar to Mumbai Cab Fare"],
    ["Pune Station to Borivali Taxi", "Pune Station to Navi Mumbai Cab Fare"],
    ["Pune Station to Mumbai Airport Cab Fare", "Pune Station to Mumbai Sedan Taxi Fare"],
    ["Ertiga on Rent in Pune Station", "Innova, Ertiga, Xylo, Tavera Car on Rent Pune Station"],
    ["Pune Station to Mumbai Airport Cab", "Pune Station to Mumbai Airport Innova"],
    ["Pune to Mumbai Skyline Cabs", "Cab Service in Pune"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"],
    ["Pune Station Cab", "Pune Station Cab Contact Number"],
    ["Full Day Taxi in Pune", "Pune Station Cab"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Pune Station to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers prompt and reliable cab services from Pune Station to Mumbai, ensuring that you reach your destination comfortably and on time. Whether you're arriving after a long train journey or heading to Mumbai for work or leisure, our service is tailored to meet your needs."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes a range of vehicles from sedans to SUVs, all meticulously maintained for a smooth, comfortable ride. With air-conditioning, plush seating, and enough space for luggage, you'll feel at ease throughout your journey from Pune Station to Mumbai."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs drivers are trained professionals with in-depth knowledge of the Pune to Mumbai route. They ensure your ride is safe, efficient, and stress-free, guiding you through the traffic while providing a friendly, courteous experience throughout the trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive rates for your Pune Station to Mumbai ride, with no hidden charges. Our transparent pricing ensures you’ll know the cost up front, so there are no surprises at the end of your trip."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel",
        "WhyChoosedescription": "Whether you’re arriving at Pune Station early in the morning or late at night, our services are available 24/7. You can count on us for any time travel, with convenient booking options via our website, mobile app, or by phone."
    },
    {
        "WhyChooseheading": "Tailored Vehicles for Every Group Size",
        "WhyChoosedescription": "Skyline Cabs offers a variety of vehicles to suit your needs. Whether you're traveling solo, with family, or in a small group, we have sedans, SUVs, and larger vehicles that can comfortably accommodate your group and luggage."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
        "WhyChoosedescription": "Booking your ride from Pune Station to Mumbai is quick and simple with our easy-to-use online platform. You can book your cab through our website or mobile app, receive instant booking confirmation, and track your ride in real-time for a smooth experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Journey Guaranteed",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with GPS for real-time tracking, and our drivers undergo thorough background checks. With Skyline Cabs, you can enjoy a secure, comfortable, and worry-free ride from Pune Station to Mumbai."
    }
]


















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Pune Station to Mumbai with Skyline Cabs?',
            answer:
                'Booking is easy! You can book a ride via our website or mobile app. Simply choose Pune Station as your pickup location, Mumbai as your destination, and select the vehicle type you prefer. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Pune Station to Mumbai?',
            answer:
                'We offer a variety of vehicles, including sedans, SUVs, Innova Crysta, Ertiga, and premium cars. You can choose the vehicle that suits your needs and comfort during the booking process.',
        },
        {
            id: 3,
            question: 'Is the fare from Pune Station to Mumbai fixed?',
            answer:
                'Yes, the fare is fixed and transparent. The total fare includes tolls, taxes, and driver charges, with no hidden fees. You will know the total cost upfront during the booking process.',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Pune Station to Mumbai?',
            answer:
                'Yes, you can easily book both one-way and round-trip rides. Just provide your return details during the booking process, and we will take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Pune Station to Mumbai?',
            answer:
                'The journey from Pune Station to Mumbai typically takes 3.5 to 4 hours, depending on traffic conditions. Our drivers are familiar with the best routes, ensuring a smooth and timely ride.',
        },
        {
            id: 6,
            question: 'Are your drivers experienced with the Pune Station to Mumbai route?',
            answer:
                'Yes, our drivers are trained, experienced, and well-acquainted with the Pune to Mumbai route. They ensure a safe, timely, and comfortable journey.',
        },
        {
            id: 7,
            question: 'Can I book a cab for an airport transfer from Pune Station to Mumbai?',
            answer:
                'Yes, we offer reliable airport transfer services. Whether you need a ride to or from Mumbai’s Domestic or International Airport, Skyline Cabs ensures timely and hassle-free transfers.',
        },
        {
            id: 8,
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer:
                'Absolutely! All of our cabs are fully air-conditioned, well-maintained, and equipped with modern amenities to ensure a comfortable and pleasant journey.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my booking after confirmation?',
            answer:
                'Yes, we offer a flexible cancellation and modification policy. You can cancel or modify your booking through our app, website, or by reaching out to our customer support team.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Pune Station to Mumbai trip?',
            answer:
                'Skyline Cabs offers competitive pricing, a range of vehicle options, and professional drivers. We prioritize punctuality, comfort, and a stress-free experience, making us the best choice for your Pune Station to Mumbai ride.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rohit Deshmukh",
            rating: 5,
            review: "I booked a cab from Pune Station to Mumbai for a business trip. The vehicle was clean, and the driver was very professional and punctual. I had a comfortable and smooth ride. Highly recommended!"
        },
        {
            name: "Miss. Shweta Patil",
            rating: 4,
            review: "The ride from Pune Station to Mumbai was pleasant. The driver was on time, and the car was in great condition. The only improvement would be to have a charging port available in the backseat for passengers, but overall, a great service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Station to Mumbai Cabs Service",
  "image": "https://skylinecabs.com/assets/images/pune-station-to-mumbai-cab.jpg",
  "description": "Book Pune Station to Mumbai cabs service with Skyline Cabs for timely pickups, affordable pricing, and 24/7 availability. Choose AC sedans or SUVs for one-way or round-trip journeys with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7892"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-station-to-mumbai-cabs-service"
  }
};


      
      
      


    return (
        <div>
<Helmet>
  <title>Pune Station to Mumbai Cabs Service | AC Taxi & On-Time Pickup | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Station to Mumbai cabs service with Skyline Cabs for timely pickups, affordable pricing, and 24/7 availability. Choose AC sedans or SUVs for one-way or round-trip journeys with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Pune Station to Mumbai Cabs Service, Cab from Pune Railway Station to Mumbai, One-Way Taxi Pune Station to Mumbai, Round Trip Cab Pune Station Mumbai, AC Sedan Cab Pune Station to Mumbai, SUV Taxi Pune Station to Mumbai, 24/7 Cab Booking Pune Station to Mumbai, Skyline Cabs Pune Station to Mumbai, Online Cabs Pune Station to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/24.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punestationtomumbaicabs;